import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { TweenMax } from 'gsap';
import styles from './index.module.scss';
import { scrollCardMap } from '@/data/ecocreditsday';
import { createEFPic } from '@/utils/useEFPic';
import CommonButton from '@/components/EcoCreditsDay/CommonButton';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

const { EFPic } = createEFPic('/media/ecocredits-day/h5/');

const scrollCardName = styles.scrollCard;
export default function ScrollCard() {
    const { locale } = useRouter();
    const scrollList = scrollCardMap[locale as keyof typeof scrollCardMap] || scrollCardMap.jp;
    const { t } = useLang('ecocreditsday');

    useEffect(() => {
        const scene = new ScrollMagic.Scene({
            triggerElement: `.${scrollCardName} .scroll-item:nth-child(1)`,
            offset: 200, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 300,
        });
        const tweenA1 = TweenMax.to(`.${scrollCardName} .scroll-item:nth-child(1) .scroll-item__box`, 0.5, { opacity: 1 });
        scene.setTween(tweenA1);
        controllerDay.addScene(scene);

        return () => {
            scene && scene?.destroy();
        };
    }, []);

    useEffect(() => {
        const scene = new ScrollMagic.Scene({
            triggerElement: `.${scrollCardName} .scroll-item:nth-child(2)`,
            offset: 200, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 300,
        });
        const tweenA1 = TweenMax.to(`.${scrollCardName} .scroll-item:nth-child(2) .scroll-item__box`, 0.5, { opacity: 1 });
        scene.setTween(tweenA1);
        controllerDay.addScene(scene);

        return () => {
            scene && scene?.destroy();
        };
    }, []);

    useEffect(() => {
        const scene = new ScrollMagic.Scene({
            triggerElement: `.${scrollCardName} .scroll-item:nth-child(3)`,
            offset: 200, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 300,
        });
        const tweenA1 = TweenMax.to(`.${scrollCardName} .scroll-item:nth-child(3) .scroll-item__box`, 0.5, { opacity: 1 });
        scene.setTween(tweenA1);
        controllerDay.addScene(scene);

        return () => {
            scene && scene?.destroy();
        };
    }, []);

    const handleClick = (item: any) => {
        if (locale !== 'jp') {
            if (item.naGtm) {
                gtm.push({
                    product_name: 'none',
                    event_name: 'buy',
                    position: 'Ecocredits-day',
                });
            } else {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'ecocredits_button',
                    type: locale === 'kr' ? 'Register' : 'Other',
                    list_name: t(`pageTabs.tab2`),
                    button_name: item.btnText,
                });
            }
        }
        window.open(item.btnLink);
    };

    return (
        <div className={styles.scrollCard}>
            <div className="scroll-card" style={{ zIndex: 9 }}>
                {scrollList.map((item: any, index) => (
                    <div className="scroll-item" key={index}>
                        <div className="scroll-item__box">
                            <div className="sub-title">{item.subTitle}</div>
                            <div className="title">{item.title}</div>
                            <div className="desc-list">
                                {(item.desc as string[])?.map((val: string, i: number) => (
                                    <div className="desc-item" key={`${index}_${i}`}>
                                        {val}
                                    </div>
                                ))}
                            </div>
                        </div>
                        {item.btnText && (
                            <div className="btn">
                                <CommonButton disabledAni padding="10px 14px" lineHeight="23px" borderRadius="8px" onClick={() => handleClick(item)}>
                                    <div className="btn-text">
                                        {item.btnText}
                                        <div className="svg-arrow"></div>
                                    </div>
                                </CommonButton>
                            </div>
                        )}
                        <EFPic className="scroll-img" name={item.src} />
                    </div>
                ))}
            </div>
        </div>
    );
}
